export const ANALYTICS_CONSENT_KEY = "analytics-consent";
export const COOKIE_CONSENT_UPDATED_EVENT = "cookie-consent-updated";
